import {
    TextField } from "../../ui";
import React,
    { useEffect,
    useState } from "react";
import SnpButton from "../../global/SnpButton";
import DismissButton from "../../global/DismissButton";
import DialogBox from "../../global/DialogBox";
import { useSelector } from "react-redux";
import { getConfigValueByKey } from "../../../utilities/commonUtilities";
import {
  GENERATEBILL
} from "../../../constants/constant";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { isEmpty } from "lodash";

const BillManagementOtpDialog = ({ title = 'Generate Bill' , showDialog, setShowDialog, handleGenerateBillWithOtp }) => {
  const { billDetails } = useSelector((state) => state.bill);
  const [generateBillOtp, setGenerateBillOtp] = useState("");
  const [generateBillOtpOption, setGenerateBillOtpOption] = useState(false);
  const restoBillConfig = useSelector((state) => state.restoBillConfig);
  const { snackbar, loader, dialog, notify } = useSnpUI();
  // useEffect(() => {
  //   setGenerateBillOtpOption(
  //     getConfigValueByKey(restoBillConfig, GENERATEBILL)
  //   );
  // }, [restoBillConfig]);

  const handleGenerateBillOtpCheck = () => {
    // if (generateBillOtpOption && !isEmpty(billDetails.generateOtp)) {
      if (
        isEmpty(generateBillOtp) ||
        generateBillOtp !== billDetails.generateOtp
      ) {
        snackbar.show({ message: "Please enter valid OTP", color: "red" });
      } else {
       //  ;
       handleGenerateBillWithOtp();
       setShowDialog(false);
       setGenerateBillOtp("");
      }
  };
  const buildGenOtpUi = () => {
    return (
      <TextField
        id="otp"
        name="otp"
        variant="filled"
        size="small"
        label={"Enter OTP"}
        defaultValue={generateBillOtp}
        onChange={(e) => setGenerateBillOtp(e.target.value)}
        style={{ width: "100%" }}
      />
    );
  };

  const buildGenOtpAction = () => {
    return (
      <>
        <SnpButton
          variant="contained"
          color="primary"
          onClick={handleGenerateBillOtpCheck}
        >
         {title}
        </SnpButton>
        <DismissButton
          variant="contained"
          color="primary"
          onClick={() => {
            setShowDialog(false);
            setGenerateBillOtp("");
          }}
        >
          Dismiss
        </DismissButton>
      </>
    );
  };

  return (
    <div>
      <DialogBox
        showDialog={showDialog}
        title={`OTP For ${title}`}
        dialogContent={buildGenOtpUi()}
        dialogActions={buildGenOtpAction()}
      ></DialogBox>
    </div>
  );
};

export default BillManagementOtpDialog;
